var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((_vm.resources),function(item){return _c('div',{key:item.key,staticClass:"col-md-3"},[_c('div',{staticClass:"py-1"},[_c('ResourceCard',{attrs:{"item":item}})],1)])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }